export default "__VITE_ASSET__ap7kX6Ku__"